export const REQUEST_LOGIN = "REQUEST_LOGIN";
export const REQUEST_REFRESH_TOKEN = "REQUEST_REFRESH_TOKEN";
export const ACCEPT_REFRESH_TOKEN = "ACCEPT_REFRESH_TOKEN";
export const ACCEPT_LOGIN = "ACCEPT_LOGIN";
export const HAS_LOGIN = "HAS_LOGIN";
export const INVALID_LOGIN = "INVALID_LOGIN";
export const NO_LOGIN = "NO_LOGIN";

export const REQUEST_LOGOUT = "REQUEST_LOGOUT";
export const SUCCESS_LOGOUT = "SUCCESS_LOGOUT";

export const AUTH_DATA = "909c10f0-2b4e-4d37-bfd0-07fc57ed694c";
export const CLIENT_MODULES_DATA = "dba4c368-e9d1-4de0-bd34-b222e2a581da";

export const CHECK_LOGIN = "CHECK_LOGIN";

export const REQUEST_ACCOUNT_HEAD = "REQUEST_ACCOUNT_HEAD";
export const RECEIVE_ACCOUNT_HEAD = "RECEIVE_ACCOUNT_HEAD";
export const RECEIVE_SINGLE_ACCOUNT_HEAD = "RECEIVE_SINGLE_ACCOUNT_HEAD";
export const RESET_EDITABLE_ACCOUNT_HEAD = "RESET_EDITABLE_ACCOUNT_HEAD";
export const FAILED_ACCOUNT_HEAD = "FAILED_ACCOUNT_HEAD";

export const REQUEST_FILTER_ACCOUNT_HEAD = "REQUEST_FILTER_ACCOUNT_HEAD";
export const RECEIVE_FILTER_ACCOUNT_HEAD = "RECEIVE_FILTER_ACCOUNT_HEAD";
export const FAILED_FILTER_ACCOUNT_HEAD = "FAILED_FILTER_ACCOUNT_HEAD";
 
export const REQUEST_ADD_NEW_ACCOUNT_HEAD = "REQUEST_ADD_NEW_ACCOUNT_HEAD";
export const SUCCESS_ADD_NEW_ACCOUNT_HEAD = "SUCCESS_ADD_NEW_ACCOUNT_HEAD";
export const FAILED_ADD_NEW_ACCOUNT_HEAD = "FAILED_ADD_NEW_ACCOUNT_HEAD";

export const REQUEST_ADD_NEW_JOURNAL = "REQUEST_ADD_NEW_JOURNAL";
export const SUCCESS_ADD_NEW_JOURNAL = "SUCCESS_ADD_NEW_JOURNAL";
export const FAILED_ADD_NEW_JOURNAL = "FAILED_ADD_NEW_JOURNAL";

export const REQUEST_UPDATE_JOURNAL = "REQUEST_UPDATE_JOURNAL";
export const SUCCESS_UPDATE_JOURNAL = "SUCCESS_UPDATE_JOURNAL";
export const FAILED_UPDATE_JOURNAL = "FAILED_UPDATE_JOURNAL";

export const REQUEST_CASH_BANK_JOURNALS = "REQUEST_CASH_BANK_JOURNALS";
export const SUCCESS_CASH_BANK_JOURNALS = "SUCCESS_CASH_BANK_JOURNALS";
export const FAILED_CASH_BANK_JOURNALS = "FAILED_CASH_BANK_JOURNALS";

export const REQUEST_JOURNALS = "REQUEST_JOURNALS";
export const RECEIVE_JOURNALS = "RECEIVE_JOURNALS";
export const RECEIVE_CASH_BANK_BALANCE = "RECEIVE_CASH_BANK_BALANCE";
export const RECEIVE_TOTAL_OPENING_BALANCE = "RECEIVE_TOTAL_OPENING_BALANCE";
export const FAILED_JOURNALS = "FAILED_JOURNALS";

export const REQUEST_FOR_TRIAL_BALANCE = "REQUEST_FOR_TRIAL_BALANCE";
export const RECEIVE_TRIAL_BALANCE = "RECEIVE_TRIAL_BALANCE";
export const FAILED_TO_GET_TRIAL_BALANCE = "FAILED_TO_GET_TRIAL_BALANCE";

export const RECEIVE_ACCOUNT_TOTAL_BALANCE = "RECEIVE_ACCOUNT_TOTAL_BALANCE";

export const SHOW_NOTIFICATION = "SHOW_NOTIFICATION";
export const HIDE_NOTIFICATION = "HIDE_NOTIFICATION";
export const REMOVE_NOTIFICATION = "REMOVE_NOTIFICATION";

export const REQUEST_ADD_PRODUCT = "REQUEST_ADD_PRODUCT";
export const REQUEST_GET_PRODUCTS = "REQUEST_GET_PRODUCTS";

export const SUCCESS_ADD_PRODUCT = "SUCCESS_ADD_PRODUCT";
export const SUCCESS_GET_PRODUCTS = "SUCCESS_GET_PRODUCTS";
export const SUCCESS_FILTERED_PRODUCTS = "SUCCESS_FILTERED_PRODUCTS";
export const SUCCESS_GET_CATEGORIES = "SUCCESS_GET_CATEGORIES";
export const SUCCESS_GET_CATEGORY = "SUCCESS_GET_CATEGORY";

export const FAILED_ADD_PRODUCT = "FAILED_ADD_PRODUCT";
export const FAILED_GET_PRODUCTS = "FAILED_GET_PRODUCTS";

export const RESET_PRODUCT = "RESET_PRODUCT";
export const RESET_PRODUCTS = "RESET_PRODUCTS";

export const REQUEST_ADD_PRODUCT_BATCH = "REQUEST_ADD_PRODUCT_BATCH";
export const REQUEST_GET_PRODUCTS_BATCHES = "REQUEST_GET_PRODUCTS_BATCHES";
export const SUCCESS_ADD_PRODUCT_BATCH = "SUCCESS_ADD_PRODUCT_BATCH";
export const SUCCESS_GET_PRODUCTS_BATCH = "SUCCESS_GET_PRODUCTS_BATCH";
export const FAILED_ADD_PRODUCT_BATCH = "FAILED_ADD_PRODUCT_BATCH";
export const FAILED_GET_PRODUCTS_BATCHES = "FAILED_GET_PRODUCTS_BATCHES";
export const SUCCESS_FILTERED_PRODUCTS_BATCHES = "SUCCESS_FILTERED_PRODUCTS_BATCHES";
export const FAILED_FILTERED_PRODUCTS_BATCHES = "FAILED_FILTERED_PRODUCTS_BATCHES";

export const REQUEST_UPDATE_PRODUCT_BATCH = "REQUEST_UPDATE_PRODUCT_BATCH";
export const SUCCESS_UPDATE_PRODUCT_BATCH = "SUCCESS_UPDATE_PRODUCT_BATCH";
export const FAILED_UPDATE_PRODUCT_BATCH = "FAILED_UPDATE_PRODUCT_BATCH";

export const REQUEST_PRODUCTS_BATCHES = "REQUEST_PRODUCTS_BATCHES";
export const RECEIVE_PRODUCTS_BATCHES = "RECEIVE_PRODUCTS_BATCHES";
export const FAILED_PRODUCTS_BATCHES = "FAILED_PRODUCTS_BATCHES";
export const REQUEST_DISCOUNTS = "REQUEST_PRODUCTS";
export const RECEIVE_DISCOUNTS = "RECEIVE_DISCOUNTS";
export const FAILED_DISCOUNTS = "FAILED_DISCOUNTS";
export const REQUEST_ADD_DISCOUNTS = "REQUEST_ADD_DISCOUNTS";
export const SUCCESS_ADD_DISCOUNTS = "SUCCESS_ADD_DISCOUNTS";
export const FAILED_ADD_DISCOUNTS = "FAILED_ADD_DISCOUNTS";
export const RESET_DISCOUNT_POSTED = "RESET_DISCOUNT_POSTED";

export const REQUEST_ADD_SALES_INVOICE = "REQUEST_ADD_SALES_INVOICE";
export const REQUEST_GET_SALES_INVOICE = "REQUEST_GET_SALES_INVOICE";

export const REQUEST_UPDATE_SALES_INVOICE = "REQUEST_UPDATE_SALES_INVOICE";
export const SUCCESS_UPDATE_SALES_INVOICE = "SUCCESS_UPDATE_SALES_INVOICE";
export const FAILED_UPDATE_SALES_INVOICE = "FAILED_UPDATE_SALES_INVOICE";

export const SUCCESS_ADD_SALES_INVOICE = "SUCCESS_ADD_SALES_INVOICE";
export const SUCCESS_GET_SALES_INVOICE = "SUCCESS_GET_SALES_INVOICE";
export const SUCCESS_FILTERED_SALES_INVOICE = "SUCCESS_FILTERED_SALES_INVOICE";

export const FAILED_ADD_SALES_INVOICE = "FAILED_ADD_SALES_INVOICE";
export const FAILED_GET_SALES_INVOICE = "FAILED_GET_SALES_INVOICE";

export const REQUEST_ADD_USER = "REQUEST_ADD_USER";
export const REQUEST_GET_USER = "REQUEST_GET_USER";

export const SUCCESS_ADD_USER = "SUCCESS_ADD_USER";
export const SUCCESS_GET_USER = "SUCCESS_GET_USER";
export const SUCCESS_FILTERED_USER = "SUCCESS_FILTERED_USER";

export const FAILED_ADD_USER = "FAILED_ADD_USER";
export const FAILED_GET_USER = "FAILED_GET_USER";

export const REQUEST_CURRENT_USER = "REQUEST_CURRENT_USER";
export const RECEIVE_CURRENT_USER = "RECEIVE_CURRENT_USER";
export const FAILED_CURRENT_USER = "FAILED_CURRENT_USER";

export const REQUEST_CHANGE_PASSWORD = "REQUEST_CHANGE_PASSWORD";
export const SUCCESS_CHANGE_PASSWORD = "SUCCESS_CHANGE_PASSWORD";
export const FAILED_CHANGE_PASSWORD = "FAILED_CHANGE_PASSWORD";

export const REQUEST_ADD_TO_USER_ROLE = "REQUEST_ADD_TO_USER_ROLE";
export const SUCCESS_ADD_TO_USER_ROLE = "SUCCESS_ADD_TO_USER_ROLE";
export const FAILED_ADD_TO_USER_ROLE = "FAILED_ADD_TO_USER_ROLE";

export const REQUEST_ADD_ROLE = "REQUEST_ADD_ROLE";
export const SUCCESS_ADD_ROLE = "SUCCESS_ADD_ROLE";
export const FAILED_ADD_ROLE = "FAILED_ADD_ROLE";

export const REQUEST_GET_ROLE = "REQUEST_GET_ROLE";
export const SUCCESS_GET_ROLE = "SUCCESS_GET_ROLE";
export const FAILED_GET_ROLE = "FAILED_GET_ROLE";

export const REQUEST_GET_MY_ROLE = "REQUEST_GET_MY_ROLE";
export const SUCCESS_GET_MY_ROLE = "SUCCESS_GET_MY_ROLE";
export const FAILED_GET_MY_ROLE = "FAILED_GET_MY_ROLE";

export const REQUEST_VALIDATE_ROLE = "REQUEST_VALIDATE_ROLE";
export const SUCCESS_VALIDATE_ROLE = "SUCCESS_VALIDATE_ROLE";
export const FAILED_VALIDATE_ROLE = "FAILED_VALIDATE_ROLE";

export const REQUEST_DELETE_ROLE = "REQUEST_DELETE_ROLE";
export const SUCCESS_DELETE_ROLE = "SUCCESS_DELETE_ROLE";
export const FAILED_DELETE_ROLE = "FAILED_DELETE_ROLE";

export const REQUEST_INCOME_STATEMENT_REPORT = "REQUEST_INCOME_STATEMENT_REPORT";
export const RECEIVE_INCOME_STATEMENT_REPORT = "RECEIVE_INCOME_STATEMENT_REPORT";
export const FAILED_INCOME_STATEMENT_REPORT = "FAILED_INCOME_STATEMENT_REPORT";

export const REQUEST_TRIAL_BALANCE_REPORT = "REQUEST_TRIAL_BALANCE_REPORT";
export const RECEIVE_TRIAL_BALANCE_REPORT = "RECEIVE_TRIAL_BALANCE_REPORT";
export const FAILED_TRIAL_BALANCE_REPORT = "FAILED_TRIAL_BALANCE_REPORT";

export const REQUEST_BALANCE_SHEET_REPORT = "REQUEST_BALANCE_SHEET_REPORT";
export const RECEIVE_BALANCE_SHEET_REPORT = "RECEIVE_BALANCE_SHEET_REPORT";
export const FAILED_BALANCE_SHEET_REPORT = "FAILED_BALANCE_SHEET_REPORT";

export const REQUEST_SALES_INVOICE_REPORT = "REQUEST_SALES_INVOICE_REPORT";
export const RECEIVE_SALES_INVOICE_REPORT = "REQUEST_SALES_INVOICE_REPORT";
export const FAILED_SALES_INVOICE_REPORT = "FAILED_SALES_INVOICE_REPORT";

export const REQUEST_GET_ACCOUNT_LOG = "REQUEST_GET_ACCOUNT_LOG";
export const SUCCESS_GET_ACCOUNT_LOG = "SUCCESS_GET_ACCOUNT_LOG";
export const FAILED_GET_ACCOUNT_LOG = "FAILED_GET_ACCOUNT_LOG";

export const REQUEST_GET_JOURNAL_LOG = "REQUEST_GET_JOURNAL_LOG";
export const SUCCESS_GET_JOURNAL_LOG = "SUCCESS_GET_JOURNAL_LOG";
export const FAILED_GET_JOURNAL_LOG = "FAILED_GET_JOURNAL_LOG";

export const REQUEST_GET_SALES_INVOICE_LOG = "REQUEST_GET_SALES_INVOICE_LOG";
export const SUCCESS_GET_SALES_INVOICE_LOG = "SUCCESS_GET_SALES_INVOICE_LOG";
export const FAILED_GET_SALES_INVOICE_LOG = "FAILED_GET_SALES_INVOICE_LOG";

export const REQUEST_GET_USER_LOG = "REQUEST_GET_USER_LOG";
export const SUCCESS_GET_USER_LOG = "SUCCESS_GET_USER_LOG";
export const FAILED_GET_USER_LOG = "FAILED_GET_USER_LOG";

export const REQUEST_ADD_ATTACHMENT = "REQUEST_ADD_ATTACHMENT";
export const SUCCESS_ADD_ATTACHMENT = "SUCCESS_ADD_ATTACHMENT";
export const FAILED_ADD_ATTACHMENT = "FAILED_ADD_ATTACHMENT";

export const REQUEST_GET_ATTACHMENT = "REQUEST_GET_ATTACHMENT";
export const SUCCESS_GET_ATTACHMENT = "SUCCESS_GET_ATTACHMENT";
export const FAILED_GET_ATTACHMENT = "FAILED_GET_ATTACHMENT";

export const REQUEST_UPDATE_ATTACHMENT = "REQUEST_UPDATE_ATTACHMENT";
export const SUCCESS_UPDATE_ATTACHMENT = "SUCCESS_UPDATE_ATTACHMENT";
export const FAILED_UPDATE_ATTACHMENT = "FAILED_UPDATE_ATTACHMENT";

export const REQUEST_GET_PRODUCTS_SALES_HISTORY = "REQUEST_GET_PRODUCTS_SALES_HISTORY";
export const SUCCESS_GET_PRODUCTS_SALES_HISTORY = "SUCCESS_GET_PRODUCTS_SALES_HISTORY";
export const FAILED_GET_PRODUCTS_SALES_HISTORY = "FAILED_GET_PRODUCTS_SALES_HISTORY";

export const REQUEST_ADD_EMPLOYEE = "REQUEST_ADD_EMPLOYEE";
export const SUCCESS_ADD_EMPLOYEE = "SUCCESS_ADD_EMPLOYEE";
export const FAILED_ADD_EMPLOYEE = "FAILED_ADD_EMPLOYEE";

export const REQUEST_GET_EMPLOYEES_LIST = "REQUEST_GET_EMPLOYEES_LIST";
export const SUCCESS_GET_EMPLOYEES_LIST = "SUCCESS_GET_EMPLOYEES_LIST";
export const FAILED_GET_EMPLOYEES_LIST = "FAILED_GET_EMPLOYEES_LIST";
export const SUCCESS_FILTER_EMPLOYEES = "SUCCESS_FILTER_EMPLOYEES";

export const REQUEST_GET_SINGLE_EMPLOYEE = "REQUEST_GET_SINGLE_EMPLOYEE";
export const SUCCESS_GET_SINGLE_EMPLOYEE = "SUCCESS_GET_SINGLE_EMPLOYEE";
export const FAILED_GET_SINGLE_EMPLOYEE = "FAILED_GET_SINGLE_EMPLOYEE";

export const REQUEST_CHECK_DUPLICATE_CODE = "REQUEST_CHECK_DUPLICATE_CODE";
export const SUCCESS_CHECK_DUPLICATE_CODE = "SUCCESS_CHECK_DUPLICATE_CODE";
export const ERROR_CHECK_DUPLICATE_CODE = "ERROR_CHECK_DUPLICATE_CODE";

export const REQUEST_ADD_EMPLOYEE_ROLE = "REQUEST_ADD_EMPLOYEE_ROLE";
export const SUCCESS_ADD_EMPLOYEE_ROLE = "SUCCESS_ADD_EMPLOYEE_ROLE";
export const FAILED_ADD_EMPLOYEE_ROLE = "FAILED_ADD_EMPLOYEE_ROLE";

export const REQUEST_UPDATE_EMPLOYEE_ROLE = "REQUEST_UPDATE_EMPLOYEE_ROLE";
export const SUCCESS_UPDATE_EMPLOYEE_ROLE = "SUCCESS_UPDATE_EMPLOYEE_ROLE";
export const FAILED_UPDATE_EMPLOYEE_ROLE = "FAILED_UPDATE_EMPLOYEE_ROLE";

export const REQUEST_GET_EMPLOYEE_ROLES = "REQUEST_GET_EMPLOYEE_ROLES";
export const SUCCESS_GET_EMPLOYEE_ROLES = "SUCCESS_GET_EMPLOYEE_ROLES";
export const FAILED_GET_EMPLOYEE_ROLES = "FAILED_GET_EMPLOYEE_ROLES";

export const REQUEST_GET_SINGLE_EMPLOYEE_ROLE = "REQUEST_GET_SINGLE_EMPLOYEE_ROLE";
export const SUCCESS_GET_SINGLE_EMPLOYEE_ROLE = "SUCCESS_GET_SINGLE_EMPLOYEE_ROLE";
export const FAILED_GET_SINGLE_EMPLOYEE_ROLE = "FAILED_GET_SINGLE_EMPLOYEE_ROLE";

export const REQUEST_CHECK_DUPLICATE_EMPLOYEE_ROLE = "REQUEST_CHECK_DUPLICATE_EMPLOYEE_ROLE";
export const SUCCESS_CHECK_DUPLICATE_EMPLOYEE_ROLE = "SUCCESS_CHECK_DUPLICATE_EMPLOYEE_ROLE";
export const ERROR_CHECK_DUPLICATE_EMPLOYEE_ROLE = "ERROR_CHECK_DUPLICATE_EMPLOYEE_ROLE";

export const REQUEST_ADD_SALES_DATA = "REQUEST_ADD_SALES_DATA";
export const SUCCESS_ADD_SALES_DATA = "SUCCESS_ADD_SALES_DATA";
export const FAILED_ADD_SALES_DATA = "FAILED_ADD_SALES_DATA";

export const REQUEST_GET_SALES_DATA = "REQUEST_GET_SALES_DATA";
export const SUCCESS_GET_SALES_DATA = "SUCCESS_GET_SALES_DATA";
export const FAILED_GET_SALES_DATA = "FAILED_GET_SALES_DATA";

export const REQUEST_GET_DISTRIBUTOR_STOCK = "REQUEST_GET_DISTRIBUTOR_STOCK";
export const SUCCESS_GET_DISTRIBUTOR_STOCK = "SUCCESS_GET_DISTRIBUTOR_STOCK";
export const FAILED_GET_DISTRIBUTOR_STOCK = "FAILED_GET_DISTRIBUTOR_STOCK";

export const REQUEST_UPDATE_DISTRIBUTOR_STOCK = "REQUEST_UPDATE_DISTRIBUTOR_STOCK";
export const SUCCESS_UPDATE_DISTRIBUTOR_STOCK = "SUCCESS_UPDATE_DISTRIBUTOR_STOCK";
export const FAILED_UPDATE_DISTRIBUTOR_STOCK = "FAILED_UPDATE_DISTRIBUTOR_STOCK";

export const REQUEST_GET_DISTRIBUTOR_SALES_REPORT = "REQUEST_GET_DISTRIBUTOR_SALES_REPORT";
export const SUCCESS_GET_DISTRIBUTOR_SALES_REPORT = "SUCCESS_GET_DISTRIBUTOR_SALES_REPORT";
export const FAILED_GET_DISTRIBUTOR_SALES_REPORT = "FAILED_GET_DISTRIBUTOR_SALES_REPORT";
export const SUCCESS_GET_FROM_DATE = "SUCCESS_GET_FROM_DATE";

export const REQUEST_GET_EMPLOYEES_SALES_REPORT = "REQUEST_GET_EMPLOYEES_SALES_REPORT";
export const SUCCESS_GET_EMPLOYEES_SALES_REPORT = "SUCCESS_GET_EMPLOYEES_SALES_REPORT";
export const FAILED_GET_EMPLOYEES_SALES_REPORT = "FAILED_GET_EMPLOYEES_SALES_REPORT";

export const REQUEST_ADD_EMPLOYEE_REGION = "REQUEST_ADD_EMPLOYEE_REGION";
export const SUCCESS_ADD_EMPLOYEE_REGION = "SUCCESS_ADD_EMPLOYEE_REGION";
export const FAILED_ADD_EMPLOYEE_REGION = "FAILED_ADD_EMPLOYEE_REGION";

export const REQUEST_GET_EMPLOYEE_REGIONS = "REQUEST_GET_EMPLOYEE_REGIONS";
export const SUCCESS_GET_EMPLOYEE_REGIONS = "SUCCESS_GET_EMPLOYEE_REGIONS";
export const FAILED_GET_EMPLOYEE_REGIONS = "FAILED_GET_EMPLOYEE_REGIONS";

export const REQUEST_UPDATE_EMPLOYEE_REGION = "REQUEST_UPDATE_EMPLOYEE_REGION";
export const SUCCESS_UPDATE_EMPLOYEE_REGION = "SUCCESS_UPDATE_EMPLOYEE_REGION";
export const FAILED_UPDATE_EMPLOYEE_REGION = "FAILED_UPDATE_EMPLOYEE_REGION";

export const REQUEST_GET_SINGLE_EMPLOYEE_REGION = "REQUEST_GET_SINGLE_EMPLOYEE_REGION";
export const SUCCESS_GET_SINGLE_EMPLOYEE_REGION = "SUCCESS_GET_SINGLE_EMPLOYEE_REGION";
export const FAILED_GET_SINGLE_EMPLOYEE_REGION = "FAILED_GET_SINGLE_EMPLOYEE_REGION";

export const REQUEST_CHECK_DUPLICATE_EMPLOYEE_REGION = "REQUEST_CHECK_DUPLICATE_EMPLOYEE_REGION";
export const SUCCESS_CHECK_DUPLICATE_EMPLOYEE_REGION = "SUCCESS_CHECK_DUPLICATE_EMPLOYEE_REGION";
export const ERROR_CHECK_DUPLICATE_EMPLOYEE_REGION = "ERROR_CHECK_DUPLICATE_EMPLOYEE_REGION";

export const REQUEST_ADD_EMPLOYEE_TERRITORY = "REQUEST_ADD_EMPLOYEE_TERRITORY";
export const SUCCESS_ADD_EMPLOYEE_TERRITORY = "SUCCESS_ADD_EMPLOYEE_TERRITORY";
export const FAILED_ADD_EMPLOYEE_TERRITORY = "FAILED_ADD_EMPLOYEE_TERRITORY";

export const REQUEST_GET_EMPLOYEE_TERRITORIES = "REQUEST_GET_EMPLOYEE_TERRITORIES";
export const SUCCESS_GET_EMPLOYEE_TERRITORIES = "SUCCESS_GET_EMPLOYEE_TERRITORIES";
export const FAILED_GET_EMPLOYEE_TERRITORIES = "FAILED_GET_EMPLOYEE_TERRITORIES";

export const REQUEST_UPDATE_EMPLOYEE_TERRITORY = "REQUEST_UPDATE_EMPLOYEE_TERRITORY";
export const SUCCESS_UPDATE_EMPLOYEE_TERRITORY = "SUCCESS_UPDATE_EMPLOYEE_TERRITORY";
export const FAILED_UPDATE_EMPLOYEE_TERRITORY = "FAILED_UPDATE_EMPLOYEE_TERRITORY";

export const REQUEST_GET_SINGLE_EMPLOYEE_TERRITORY = "REQUEST_GET_SINGLE_EMPLOYEE_TERRITORY";
export const SUCCESS_GET_SINGLE_EMPLOYEE_TERRITORY = "SUCCESS_GET_SINGLE_EMPLOYEE_TERRITORY";
export const FAILED_GET_SINGLE_EMPLOYEE_TERRITORY = "FAILED_GET_SINGLE_EMPLOYEE_TERRITORY";

export const REQUEST_CHECK_DUPLICATE_EMPLOYEE_TERRITORY = "REQUEST_CHECK_DUPLICATE_EMPLOYEE_TERRITORY";
export const SUCCESS_CHECK_DUPLICATE_EMPLOYEE_TERRITORY = "SUCCESS_CHECK_DUPLICATE_EMPLOYEE_TERRITORY";
export const ERROR_CHECK_DUPLICATE_EMPLOYEE_TERRITORY = "ERROR_CHECK_DUPLICATE_EMPLOYEE_TERRITORY";

export const REQUEST_GET_EMPLOYEE_DISTRIBUTORS = "REQUEST_GET_EMPLOYEE_DISTRIBUTORS";
export const SUCCESS_GET_EMPLOYEE_DISTRIBUTORS = "SUCCESS_GET_EMPLOYEE_DISTRIBUTORS";
export const FAILED_GET_EMPLOYEE_DISTRIBUTORS = "FAILED_GET_EMPLOYEE_DISTRIBUTORS";

export const REQUEST_ADD_EMPLOYEE_DISTRIBUTORS = "REQUEST_ADD_EMPLOYEE_DISTRIBUTORS";
export const SUCCESS_ADD_EMPLOYEE_DISTRIBUTORS = "SUCCESS_ADD_EMPLOYEE_DISTRIBUTORS";
export const FAILED_ADD_EMPLOYEE_DISTRIBUTORS = "FAILED_ADD_EMPLOYEE_DISTRIBUTORS";

export const REQUEST_ADD_EMPLOYEE_LOCATION = "REQUEST_ADD_EMPLOYEE_LOCATION";
export const SUCCESS_ADD_EMPLOYEE_LOCATION = "SUCCESS_ADD_EMPLOYEE_LOCATION";
export const FAILED_ADD_EMPLOYEE_LOCATION = "FAILED_ADD_EMPLOYEE_LOCATION";

export const REQUEST_GET_EMPLOYEE_LOCATIONS = "REQUEST_GET_EMPLOYEE_LOCATIONS";
export const SUCCESS_GET_EMPLOYEE_LOCATIONS = "SUCCESS_GET_EMPLOYEE_LOCATIONS";
export const FAILED_GET_EMPLOYEE_LOCATIONS = "FAILED_GET_EMPLOYEE_LOCATIONS";

export const REQUEST_UPDATE_EMPLOYEE_LOCATION = "REQUEST_UPDATE_EMPLOYEE_LOCATION";
export const SUCCESS_UPDATE_EMPLOYEE_LOCATION = "SUCCESS_UPDATE_EMPLOYEE_LOCATION";
export const FAILED_UPDATE_EMPLOYEE_LOCATION = "FAILED_UPDATE_EMPLOYEE_LOCATION";

export const REQUEST_GET_SINGLE_EMPLOYEE_LOCATION = "REQUEST_GET_SINGLE_EMPLOYEE_LOCATION";
export const SUCCESS_GET_SINGLE_EMPLOYEE_LOCATION = "SUCCESS_GET_SINGLE_EMPLOYEE_LOCATION";
export const FAILED_GET_SINGLE_EMPLOYEE_LOCATION = "FAILED_GET_SINGLE_EMPLOYEE_LOCATION";

export const REQUEST_CHECK_DUPLICATE_EMPLOYEE_LOCATION = "REQUEST_CHECK_DUPLICATE_EMPLOYEE_LOCATION";
export const SUCCESS_CHECK_DUPLICATE_EMPLOYEE_LOCATION = "SUCCESS_CHECK_DUPLICATE_EMPLOYEE_LOCATION";
export const ERROR_CHECK_DUPLICATE_EMPLOYEE_LOCATION = "ERROR_CHECK_DUPLICATE_EMPLOYEE_LOCATION";

export const REQUEST_ADD_EMPLOYEE_ROUTE = "REQUEST_ADD_EMPLOYEE_ROUTE";
export const SUCCESS_ADD_EMPLOYEE_ROUTE = "SUCCESS_ADD_EMPLOYEE_ROUTE";
export const FAILED_ADD_EMPLOYEE_ROUTE = "FAILED_ADD_EMPLOYEE_ROUTE";

export const REQUEST_GET_EMPLOYEE_ROUTES = "REQUEST_GET_EMPLOYEE_ROUTES";
export const SUCCESS_GET_EMPLOYEE_ROUTES = "SUCCESS_GET_EMPLOYEE_ROUTES";
export const FAILED_GET_EMPLOYEE_ROUTES = "FAILED_GET_EMPLOYEE_ROUTES";

export const REQUEST_UPDATE_EMPLOYEE_ROUTE = "REQUEST_UPDATE_EMPLOYEE_ROUTE";
export const SUCCESS_UPDATE_EMPLOYEE_ROUTE = "SUCCESS_UPDATE_EMPLOYEE_ROUTE";
export const FAILED_UPDATE_EMPLOYEE_ROUTE = "FAILED_UPDATE_EMPLOYEE_ROUTE";

export const REQUEST_GET_SINGLE_EMPLOYEE_ROUTE = "REQUEST_GET_SINGLE_EMPLOYEE_ROUTE";
export const SUCCESS_GET_SINGLE_EMPLOYEE_ROUTE = "SUCCESS_GET_SINGLE_EMPLOYEE_ROUTE";
export const FAILED_GET_SINGLE_EMPLOYEE_ROUTE = "FAILED_GET_SINGLE_EMPLOYEE_ROUTE";

export const REQUEST_CHECK_DUPLICATE_EMPLOYEE_ROUTE = "REQUEST_CHECK_DUPLICATE_EMPLOYEE_ROUTE";
export const SUCCESS_CHECK_DUPLICATE_EMPLOYEE_ROUTE = "SUCCESS_CHECK_DUPLICATE_EMPLOYEE_ROUTE";
export const ERROR_CHECK_DUPLICATE_EMPLOYEE_ROUTE = "ERROR_CHECK_DUPLICATE_EMPLOYEE_ROUTE";

export const REQUEST_UPDATE_EMPLOYEE_STATUS = "REQUEST_UPDATE_EMPLOYEE_STATUS";
export const SUCCESS_UPDATE_EMPLOYEE_STATUS = "SUCCESS_UPDATE_EMPLOYEE_STATUS";
export const FAILED_UPDATE_EMPLOYEE_STATUS = "FAILED_UPDATE_EMPLOYEE_STATUS";

export const REQUEST_GET_DISTRIBUTOR = "REQUEST_GET_DISTRIBUTOR";
export const SUCCESS_GET_DISTRIBUTOR = "SUCCESS_GET_DISTRIBUTOR";
export const FAILED_GET_DISTRIBUTOR = "FAILED_GET_DISTRIBUTOR";

export const REQUEST_GET_ASSIGNED_TERRITORY = "REQUEST_GET_ASSIGNED_TERRITORY";
export const SUCCESS_GET_ASSIGNED_TERRITORY = "SUCCESS_GET_ASSIGNED_TERRITORY";
export const FAILED_GET_ASSIGNED_TERRITORY = "FAILED_GET_ASSIGNED_TERRITORY";

export const RESET_ACCOUNT = "RESET_ACCOUNT";
export const REQUEST_ADD_CHALLAN_INVOICE = "REQUEST_ADD_CHALLAN_INVOICE";
export const SUCCESS_ADD_CHALLAN_INVOICE = "SUCCESS_ADD_CHALLAN_INVOICE";
export const FAILED_ADD_CHALLAN_INVOICE = "FAILED_ADD_CHALLAN_INVOICE";

export const REQUEST_GET_CHALLAN_INVOICE = "REQUEST_GET_CHALLAN_INVOICE";
export const SUCCESS_GET_CHALLAN_INVOICE = "SUCCESS_GET_CHALLAN_INVOICE";
export const FAILED_GET_CHALLAN_INVOICE = "FAILED_GET_CHALLAN_INVOICE";

export const REQUEST_DELETE_CHALLAN_INVOICE = "REQUEST_DELETE_CHALLAN_INVOICE";
export const SUCCESS_DELETE_CHALLAN_INVOICE = "SUCCESS_DELETE_CHALLAN_INVOICE";
export const FAILED_DELETE_CHALLAN_INVOICE = "FAILED_DELETE_CHALLAN_INVOICE";

export const REQUEST_GET_SINGLE_CHALLAN = "REQUEST_GET_SINGLE_CHALLAN";
export const SUCCESS_GET_SINGLE_CHALLAN = "SUCCESS_GET_SINGLE_CHALLAN";
export const FAILED_GET_SINGLE_CHALLAN = "FAILED_GET_SINGLE_CHALLAN";

export const REQUEST_UPDATE_CHALLAN_INVOICE = "REQUEST_UPDATE_CHALLAN_INVOICE";
export const SUCCESS_UPDATE_CHALLAN_INVOICE = "SUCCESS_UPDATE_CHALLAN_INVOICE";
export const FAILED_UPDATE_CHALLAN_INVOICE = "FAILED_UPDATE_CHALLAN_INVOICE";

export const REQUEST_GET_FILTER_CHALLAN = "REQUEST_GET_FILTER_CHALLAN";
export const SUCCESS_GET_FILTER_CHALLAN = "SUCCESS_GET_FILTER_CHALLAN";
export const FAILED_GET_FILTER_CHALLAN = "FAILED_GET_FILTER_CHALLAN";

export const REQUEST_GET_CLIENT_DISCOUNTS = "REQUEST_GET_CLIENT_DISCOUNTS";
export const SUCCESS_GET_CLIENT_DISCOUNTS = "SUCCESS_GET_CLIENT_DISCOUNTS";
export const FAILED_GET_CLIENT_DISCOUNTS = "FAILED_GET_CLIENT_DISCOUNTS";

export const RESET_ATTACHMENT = "RESET_ATTACHMENT";
export const RESET_REPORT = "RESET_REPORT";
export const RESET_SINGLE_EMPLOYEE = "Constants.RESET_SINGLE_EMPLOYEE";
export const RESET_SINGLE_EMPLOYEE_ROLE = "Constants.RESET_SINGLE_EMPLOYEE_ROLE";
export const RESET_SINGLE_EMPLOYEE_REGION = "Constants.RESET_SINGLE_EMPLOYEE_REGION";
export const RESET_SINGLE_EMPLOYEE_TERRITORY = "Constants.RESET_SINGLE_EMPLOYEE_TERRITORY";
export const RESET_SINGLE_EMPLOYEE_LOCATION = "Constants.RESET_SINGLE_EMPLOYEE_LOCATION";
export const RESET_SINGLE_EMPLOYEE_ROUTE = "Constants.RESET_SINGLE_EMPLOYEE_ROUTE";
export const RESET_SALES_DATA = "RESET_SALES_DATA";
export const RESET_DISTRIBUTOR_STOCK = "RESET_DISTRIBUTOR_STOCK";
export const REQUEST_CLEAR_ERROR_SUCCESS = "REQUEST_CLEAR_ERROR_SUCCESS";
export const RESET_EMPLOYEE_AREA = "RESET_EMPLOYEE_AREA"
export const RESET_CHALLAN_INVOICE = "RESET_CHALLAN_INVOICE";
export const RESET_SALES_INVOICE = "RESET_SALES_INVOICE";
export const RESET_EMPLOYEES = "RESET_EMPLOYEES";

export const REQUEST_ADD_STOCK = "REQUEST_ADD_STOCK";
export const SUCCESS_ADD_STOCK = "SUCCESS_ADD_STOCK";
export const FAILED_ADD_STOCK = "FAILED_ADD_STOCK";

export const REQUEST_GET_STOCKS = "REQUEST_GET_STOCKS";
export const SUCCESS_GET_STOCKS = "SUCCESS_GET_STOCKS";
export const FAILED_GET_STOCKS = "FAILED_GET_STOCKS";

export const REQUEST_GET_FILTER_STOCK = "REQUEST_GET_FILTER_STOCK";
export const SUCCESS_GET_FILTER_STOCK = "SUCCESS_GET_FILTER_STOCK";
export const FAILED_GET_FILTER_STOCK = "FAILED_GET_FILTER_STOCK";


export const REQUEST_ADD_STOCK_PACK = "REQUEST_ADD_STOCK_PACK";
export const SUCCESS_ADD_STOCK_PACK = "SUCCESS_ADD_STOCK_PACK";
export const FAILED_ADD_STOCK_PACK = "FAILED_ADD_STOCK_PACK";

export const REQUEST_GET_PACK_SIZE = "REQUEST_GET_PACK_SIZE";
export const SUCCESS_GET_PACK_SIZE = "SUCCESS_GET_PACK_SIZE";
export const FAILED_GET_PACK_SIZE = "FAILED_GET_PACK_SIZE";

export const REQUEST_ADD_STOCK_ITEM = "REQUEST_ADD_STOCK_ITEM";
export const SUCCESS_ADD_STOCK_ITEM = "SUCCESS_ADD_STOCK_ITEM";
export const FAILED_ADD_STOCK_ITEM = "FAILED_ADD_STOCK_ITEM";

export const REQUEST_ADD_STOCK_ITEM_AND_PRODUCT = "REQUEST_ADD_STOCK_ITEM_AND_PRODUCT";
export const SUCCESS_ADD_STOCK_ITEM_AND_PRODUCT = "SUCCESS_ADD_STOCK_ITEM_AND_PRODUCT";
export const FAILED_ADD_STOCK_ITEM_AND_PRODUCT = "FAILED_ADD_STOCK_ITEM_AND_PRODUCT";
    
export const REQUEST_GET_STOCK_ITEM = "REQUEST_GET_STOCK_ITEM";
export const SUCCESS_GET_STOCK_ITEM = "SUCCESS_GET_STOCK_ITEM";
export const FAILED_GET_STOCK_ITEM = "FAILED_GET_STOCK_ITEM";

export const REQUEST_GET_SINGLE_STOCK_ITEM = "REQUEST_GET_SINGLE_STOCK_ITEM";
export const SUCCESS_GET_SINGLE_STOCK_ITEM = "SUCCESS_GET_SINGLE_STOCK_ITEM";
export const FAILED_GET_SINGLE_STOCK_ITEM = "FAILED_GET_SINGLE_STOCK_ITEM";

export const REQUEST_ADD_STOCK_PRICE = "REQUEST_ADD_STOCK_PRICE";
export const SUCCESS_ADD_STOCK_PRICE = "SUCCESS_ADD_STOCK_PRICE";
export const FAILED_ADD_STOCK_PRICE = "FAILED_ADD_STOCK_PRICE";

export const REQUEST_GET_FILTER_BARCODE = "REQUEST_GET_FILTER_BARCODE";
export const SUCCESS_GET_FILTER_BARCODE = "SUCCESS_GET_FILTER_BARCODE";
export const FAILED_GET_FILTER_BARCODE = "FAILED_GET_FILTER_BARCODE";

export const REQUEST_GET_SINGLE_PRODUCT = "REQUEST_GET_SINGLE_PRODUCT";
export const SUCCESS_GET_SINGLE_PRODUCT = "SUCCESS_GET_SINGLE_PRODUCT";
export const FAILED_GET_SINGLE_PRODUCT = "FAILED_GET_SINGLE_PRODUCT"; 

export const REQUEST_ADD_STOCK_SALES_INVOICE = "REQUEST_ADD_STOCK_SALES_INVOICE";
export const SUCCESS_ADD_STOCK_SALES_INVOICE = "SUCCESS_ADD_STOCK_SALES_INVOICE";
export const FAILED_ADD_STOCK_SALES_INVOICE = "FAILED_ADD_STOCK_SALES_INVOICE";

export const REQUEST_GET_FILTER_BRANCH = "REQUEST_GET_FILTER_BRANCH";
export const SUCCESS_GET_FILTER_BRANCH = "SUCCESS_GET_FILTER_BRANCH";
export const FAILED_GET_FILTER_BRANCH = "FAILED_GET_FILTER_BRANCH";

export const REQUEST_GET_SINGLE_PRODUCT_DETAILS = "REQUEST_GET_SINGLE_PRODUCT_DETAILS";
export const SUCCESS_GET_SINGLE_PRODUCT_DETAILS = "SUCCESS_GET_SINGLE_PRODUCT_DETAILS";
export const FAILED_GET_SINGLE_PRODUCT_DETAILS = "FAILED_GET_SINGLE_PRODUCT_DETAILS";

export const REQUEST_GET_BRANCH_STOCKS = "REQUEST_GET_BRANCH_STOCKS";
export const SUCCESS_GET_BRANCH_STOCKS = "SUCCESS_GET_BRANCH_STOCKS";
export const FAILED_GET_BRANCH_STOCKS = "FAILED_GET_BRANCH_STOCKS";

export const REQUEST_ADD_BRANCH = "REQUEST_ADD_BRANCH";
export const SUCCESS_ADD_BRANCH = "SUCCESS_ADD_BRANCH";
export const FAILED_ADD_BRANCH = "FAILED_ADD_BRANCH";


export const REQUEST_GET_BRANCHES = "REQUEST_GET_BRANCHES";
export const SUCCESS_GET_BRANCHES = "SUCCESS_GET_BRANCHES";
export const FAILED_GET_BRANCHES = "FAILED_GET_BRANCHES";

export const RESET_ORG_UNIT = "RESET_ORG_UNIT";

export const REQUEST_TRANSFER_STOCK_ITEMS = "REQUEST_TRANSFER_STOCK_ITEMS";
export const SUCCESS_TRANSFER_STOCK_ITEMS = "SUCCESS_TRANSFER_STOCK_ITEMS";
export const FAILED_TRANSFER_STOCK_ITEMS = "FAILED_TRANSFER_STOCK_ITEMS";

export const REQUEST_GET_SINGLE_PENDING_STOCK_ITEM = "REQUEST_GET_SINGLE_PENDING_STOCK_ITEM";
export const SUCCESS_GET_SINGLE_PENDING_STOCK_ITEM = "SUCCESS_GET_SINGLE_PENDING_STOCK_ITEM";
export const FAILED_GET_SINGLE_PENDING_STOCK_ITEM = "FAILED_GET_SINGLE_PENDING_STOCK_ITEM";

export const REQUEST_RECEIVE_STOCK_ITEMS = "REQUEST_RECEIVE_STOCK_ITEMS";
export const SUCCESS_RECEIVE_STOCK_ITEMS = "SUCCESS_RECEIVE_STOCK_ITEMS";
export const FAILED_RECEIVE_STOCK_ITEMS = "FAILED_RECEIVE_STOCK_ITEMS";

export const REQUEST_GET_PENDING_STOCKS = "REQUEST_GET_PENDING_STOCKS";
export const SUCCESS_GET_PENDING_STOCKS = "SUCCESS_GET_PENDING_STOCKS";
export const FAILED_GET_PENDING_STOCKS = "FAILED_GET_PENDING_STOCKS";

export const RESET_STOCK = "RESET_STOCK";

export const REQUEST_GET_BRANCH = "REQUEST_GET_BRANCH";
export const SUCCESS_GET_BRANCH = "SUCCESS_GET_BRANCH";
export const FAILED_GET_BRANCH = "FAILED_GET_BRANCH";

export const REQUEST_UPDATE_BRANCH = "REQUEST_UPDATE_BRANCH";
export const SUCCESS_UPDATE_BRANCH = "SUCCESS_UPDATE_BRANCH";
export const FAILED_UPDATE_BRANCH = "FAILED_UPDATE_BRANCH";

export const REQUEST_ADD_BANK_CHEQUE = "REQUEST_ADD_BANK_CHEQUE";
export const SUCCESS_ADD_BANK_CHEQUE = "SUCCESS_ADD_BANK_CHEQUE";
export const FAILED_ADD_BANK_CHEQUE = "FAILED_ADD_BANK_CHEQUE";

export const REQUEST_GET_BANK_CHEQUES = "REQUEST_GET_BANK_CHEQUES";
export const SUCCESS_GET_BANK_CHEQUES = "SUCCESS_GET_BANK_CHEQUES";
export const FAILED_GET_BANK_CHEQUES = "FAILED_GET_BANK_CHEQUES";

export const REQUEST_UPDATE_BANK_CHEQUE_STATUS = "REQUEST_UPDATE_BANK_CHEQUE_STATUS";
export const SUCCESS_UPDATE_BANK_CHEQUE_STATUS = "SUCCESS_UPDATE_BANK_CHEQUE_STATUS";
export const FAILED_UPDATE_BANK_CHEQUE_STATUS = "FAILED_UPDATE_BANK_CHEQUE_STATUS";

export const RESET_BANK_CHEQUE = "RESET_BANK_CHEQUE";

export const REQUEST_CHECK_DUPLICATE_CHEQUE_NUMBER = "REQUEST_CHECK_DUPLICATE_CHEQUE_NUMBER";
export const SUCCESS_CHECK_DUPLICATE_CHEQUE_NUMBER = "SUCCESS_CHECK_DUPLICATE_CHEQUE_NUMBER";
export const FAILED_CHECK_DUPLICATE_CHEQUE_NUMBER = "FAILED_CHECK_DUPLICATE_CHEQUE_NUMBER";

export const REQUEST_COMPONENT_CONFIGURATION = "REQUEST_COMPONENT_CONFIGURATION";
export const RECEIVE_COMPONENT_CONFIGURATION = "RECEIVE_COMPONENT_CONFIGURATION";
export const FAILED_COMPONENT_CONFIGURATION = "FAILED_COMPONENT_CONFIGURATION";
export const RESET_COMPONENT_CONFIGURATION = "RESET_COMPONENT_CONFIGURATION";

export const GET_CLIENT_MODULES = "GET_CLIENT_MODULES";
export const SET_CLIENT_MODULES = "SET_CLIENT_MODULES";

export const REQUEST_ADD_PAYMENT_ACCOUNT_HEAD = "REQUEST_ADD_PAYMENT_ACCOUNT_HEAD";
export const SUCCESS_ADD_PAYMENT_ACCOUNT_HEAD = "SUCCESS_ADD_PAYMENT_ACCOUNT_HEAD";
export const FAILED_ADD_PAYMENT_ACCOUNT_HEAD = "FAILED_ADD_PAYMENT_ACCOUNT_HEAD";

export const REQUEST_ADD_CATEGORY = "REQUEST_ADD_CATEGORY";
export const SUCCESS_ADD_CATEGORY = "SUCCESS_ADD_CATEGORY";
export const FAILED_ADD_CATEGORY = "FAILED_ADD_CATEGORY";

export const REQUEST_ADD_PURCHASE_INVOICE = "REQUEST_ADD_PURCHASE_INVOICE";
export const SUCCESS_ADD_PURCHASE_INVOICE = "SUCCESS_ADD_PURCHASE_INVOICE";
export const FAILED_ADD_PURCHASE_INVOICE = "FAILED_ADD_PURCHASE_INVOICE";
export const RESET_PURCHASE_INVOICE = "RESET_PURCHASE_INVOICE";

export const REQUEST_GET_PURCHASE_INVOICE = "REQUEST_GET_PURCHASE_INVOICE";
export const SUCCESS_GET_PURCHASE_INVOICE = "SUCCESS_GET_PURCHASE_INVOICE";
export const FAILED_GET_PURCHASE_INVOICE = "FAILED_GET_PURCHASE_INVOICE";

export const REQUEST_APPROVE_STOCK_TRANSFER = "REQUEST_APPROVE_STOCK_TRANSFER";
export const SUCCESS_APPROVE_STOCK_TRANSFER = "SUCCESS_APPROVE_STOCK_TRANSFER";
export const FAILED_APPROVE_STOCK_TRANSFER = "FAILED_APPROVE_STOCK_TRANSFER";


// WEBPACK FOOTER //
// ./src/common/Constants.js